<div class="jumbotron text-center img-align">
    <img src="assets/images/link-expired.png">
</div>